import Vue from 'vue';
import Vuex from 'vuex';
import location from './modules/location'
import tabSelect from './modules/tabSelect'
Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		location,
		tabSelect
	},
});
